let audioElement: HTMLAudioElement | null = null;
let isUnlocked = false;

// Initialize the audio element with the given URL
// Optionally try to unlock immediately (works if called soon after user gesture)
export const initAudio = (url: string, tryUnlock = false) => {
  if (audioElement) return;

  audioElement = new Audio(url);
  audioElement.loop = true;
  audioElement.preload = 'auto';
  // iOS requires playsinline attribute
  audioElement.setAttribute('playsinline', 'true');
  audioElement.setAttribute('webkit-playsinline', 'true');
  audioElement.load();

  // Try to unlock immediately if requested (may work if called during navigation)
  if (tryUnlock) {
    warmUpAudio();
  }
};

// Call this on ANY user gesture (click/touch) to unlock audio on iOS
// Once unlocked, the same audio element can be played programmatically later
export const warmUpAudio = () => {
  if (isUnlocked || !audioElement) return;

  audioElement.muted = true;
  audioElement
    .play()
    .then(() => {
      audioElement!.pause();
      audioElement!.muted = false;
      audioElement!.currentTime = 0;
      isUnlocked = true;
    })
    .catch(() => {
      // Ignore — will retry on next user gesture
    });
};

// Play the alert sound (works after warmUpAudio has been called)
export const playAlert = () => {
  if (!audioElement) return;

  audioElement.muted = false;
  audioElement.currentTime = 0;
  audioElement.play().catch((e) => {
    console.warn('Audio play failed:', e);
  });
};

// Check if audio has been unlocked by a user gesture
export const isAudioUnlocked = () => isUnlocked;

// Stop the alert sound
export const stopAlert = () => {
  if (!audioElement) return;

  try {
    audioElement.pause();
    audioElement.currentTime = 0;
  } catch (e) {
    console.log('Stop error:', e);
  }
};
